





























































import {
  defineComponent,
  computed,
  onMounted,
  onUnmounted,
  ref,
  Ref,
  reactive
} from "@vue/composition-api";

export default defineComponent({
  props: {
    value: {
      default: ""
    },
    msg: {
      default: "Choose a PIN code"
    },
    open: {
      default: true
    }
  },
  setup(props, { emit }) {
    const color = "rgba(255, 255, 255, .05)";
    const keyMap = reactive({
      del: ref<null | Vue>(null),
      key0: ref<null | Vue>(null),
      key1: ref<null | Vue>(null),
      key2: ref<null | Vue>(null),
      key3: ref<null | Vue>(null),
      key4: ref<null | Vue>(null),
      key5: ref<null | Vue>(null),
      key6: ref<null | Vue>(null),
      key7: ref<null | Vue>(null),
      key8: ref<null | Vue>(null),
      key9: ref<null | Vue>(null)
    });

    const pin = computed({
      get: () => props.value,
      set(value: string) {
        emit("input", value);
        if (value.length === 6 && value !== props.value) {
          setTimeout(() => emit("submit", value), 200);
        }
      }
    });

    const enter = (value: number) => {
      if (pin.value.length === 6) return;
      pin.value += value;
    };

    const backspace = () => {
      pin.value = pin.value.substr(0, pin.value.length - 1);
    };

    onMounted(() => {
      document.addEventListener("keydown", keydown);
    });

    onUnmounted(() => {
      document.removeEventListener("keydown", keydown);
    });

    const keydown = (e: KeyboardEvent) => {
      if (!props.open) return;
      const focus = (name: string) => {
        try {
          const el = (): HTMLInputElement | undefined =>
            keyMap[name] &&
            ((keyMap[name] as Ref<Vue>).value?.$el as HTMLInputElement);
          setTimeout(() => el()?.focus(), 50);
          setTimeout(() => el()?.blur(), 200);
        } catch {
          console.warn("Could not focus");
        }
      };

      if (e.code === "Backspace") {
        backspace();
        focus("del");
      } else if (
        ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key)
      ) {
        enter(+e.key);
        focus("key" + e.key);
      }
    };

    return {
      color,
      pin,
      enter,
      backspace,
      keydown,
      ...keyMap
    };
  }
});
